module.exports = __webpack_public_path__ + "static/img/entry-modal-bg.f13e03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-sign-in/entry-modal-bg.png
// module id = V8C2
// module chunks = 216